import { pageStart } from "./adobe-analytics";

const TrackPageStart = () => {
  pageStart();
  return null;
};

export default TrackPageStart;